import { jsx as _jsx } from "react/jsx-runtime";
import { TS_PropRenderer } from '../TS_PropRenderer/index.js';
import { Controller } from '../../core/Controller.js';
export class TS_EditableContent extends Controller {
    shouldReDeriveState(nextProps) {
        // if (!this.state)
        // 	throw new BadImplementationException(`Check if you have overridden 'deriveStateFromProps' without calling super.`);
        if (this.state.tag !== nextProps.editable.tag)
            return true;
        return super.shouldReDeriveState(nextProps);
    }
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (this.state.tag !== nextState.editable.tag)
            return true;
        return super.shouldComponentUpdate(nextProps, nextState, nextContext);
    }
    deriveStateFromProps(nextProps, state) {
        state.editable = nextProps.editable;
        state.tag = nextProps.editable.tag;
        return state;
    }
    renderProp(label, render, className) {
        return this.renderPropVertical(label, render, className);
    }
    renderPropVertical(label, render, className) {
        return (_jsx(TS_PropRenderer.Vertical, { label: label, className: className, children: render }));
    }
    renderPropHorizontal(label, render, className) {
        return (_jsx(TS_PropRenderer.Horizontal, { label: label, className: className, children: render }));
    }
    item = () => this.state.editable.item;
}
//# sourceMappingURL=TS_EditableContent.js.map